export enum AnlageTyp {
  BESONDERER_BEDARF = 'BESONDERER_BEDARF',
  EINKOMMEN = 'EINKOMMEN',
  EINKOMMEN_SELBSTAENDIGE_TAETIGKEIT = 'EINKOMMEN_SELBSTAENDIGE_TAETIGKEIT',
  HAUSHALTSGEMEINSCHAFT = 'HAUSHALTSGEMEINSCHAFT',
  KIND = 'KIND',
  KOSTEN_DER_UNTERKUNFT = 'KOSTEN_DER_UNTERKUNFT',
  MEHRBEDARF = 'MEHRBEDARF',
  SCHWEIGEPFLICHTENTBINDUNG = 'SCHWEIGEPFLICHTENTBINDUNG',
  SOZIALVERSICHERUNG = 'SOZIALVERSICHERUNG',
  UNTERHALT_ELTERN = 'UNTERHALT_ELTERN',
  UNTERHALT_GETRENNT = 'UNTERHALT_GETRENNT',
  UNTERHALT_KIND = 'UNTERHALT_KIND',
  UNTERHALT_SCHWANGERSCHAFT = 'UNTERHALT_SCHWANGERSCHAFT',
  VERANTWORTUNGSGEMEINSCHAFT = 'VERANTWORTUNGSGEMEINSCHAFT',
  VERMOEGEN = 'VERMOEGEN',
  WEITERE_PERSON = 'WEITERE_PERSON',
  KONTOAUSZUEGE = 'KONTOAUSZUEGE'
}
